<template>
  <main>
    <vue-headful
      :title="'Enjoj | ' + surrounding.name + ' - Aanbiedingen'"
      :description="surrounding.description"
      :image="surrounding.banner"
    />
    <ec-page-heading
      :paragraph="paragraph"
      :sub-title="subTitle"
      :title="pageTitle"
      class="intro-text wrapper pt-5 pb-5"
    />
    <ec-discount-list
      v-loading="isLoading"
      :discounts="results"
      :pageSize="pageSize"
      :total="total"
      :changePage="setPage"
      class="wrapper pt-5 pb-5"
    >
      <ec-filter
          :filters="this.discountFilter"
          name="discount"
          position="start"
          @filter="filterItems"
        />
    </ec-discount-list>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import Surrounding from '@/mixins/Surrounding'
import ecPageHeading from '@/components/General/PageHeading'
import ecDiscountList from '@/components/Discount/List'
import ecFilter from '@/components/General/Element/Filter'
import Discounts from '@/mixins/Discounts'
import Location from '@/mixins/Location'
import Filter from '@/mixins/Filter'

export default {
  name: 'ec-discount-index',
  components: {
    ecPageHeading,
    ecDiscountList,
    ecFilter
  },
  mixins: [
    Surrounding,
    Filter,
    Location,
    Discounts
  ],
  data () {
    return {
      results: [],
      total: 0,
      current: 1,
      pageSize: 10,
      isLoading: false
    }
  },
  computed: {
    ...mapState([
      'surroundingLoaded',
      'discounts',
      'discountFilter',
      'surrounding'
    ]),
    ...mapState({
      currentFilter: state => state.currentFilter.discount
    }),
    pageTitle () {
      return 'Aanbiedingen'
    },
    paragraph () {
      return 'Klik op de aanbieding om de actie of actiefolder te bekijken'
    },
    subTitle () {
      return 'Alle lokale acties in één overzicht!'
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === null) {
      next(vm => {
        vm.getSiteData()
      })
    } else {
      next(vm => {
        if (vm.surroundingLoaded) {
          vm.setData()
        }
      })
    }
  },
  methods: {
    filterItems (filter) {
      this.isLoading = true

      this.$store.commit('setCurrentFilter', { name: 'discount', filter })
      const discounts = this.filterDiscounts(filter, this.discounts)

      this.current = 1
      this.setPagination(discounts)

      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
    setPagination (discounts) {
      this.isLoading = true
      const end = this.current * this.pageSize
      const start = end - this.pageSize
      this.total = discounts.length
      this.results = discounts.slice(start, end)
      setTimeout(() => {
        this.isLoading = false
      }, 200)
    },
    setPage (value) {
      this.current = value
      this.setPagination(this.filterDiscounts(this.currentFilter, this.discounts))
    },
    setData () {
      this.isLoading = true
      if (this.discounts.length === 0) {
        this.getDiscounts().then(() => {
          this.isLoading = false
          this.filterItems(this.currentFilter)
        }).catch(err => console.log(err))
      } else {
        this.filterItems(this.currentFilter)
      }
    }
  },
  watch: {
    surroundingLoaded (condition) {
      if (condition) {
        this.$store.commit('setIsLoading', false)
        this.setData()
      }
    }
  }
}
</script>
